import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=176d7ea2&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=176d7ea2&prod&lang=scss&scoped=true&"
import style1 from "./Collection.vue?vue&type=style&index=1&id=176d7ea2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d7ea2",
  null
  
)

export default component.exports